import React from 'react';

import TrelloCard from './TrelloCard'


function TrelloColumn({ state, setState, col, content, user }) {
  return (
    <>
      <div className='col-span-1 duration-300 place-content-start grid grid-cols-1 w-full text-center p-2 bg-gray-100 my-shadow min-h-[32rem]'>
        <div className='col-span-1 w-full text-center'>
          <h2>{content}</h2>
        </div>
        {Object.keys(state).filter(key => ((col === 'verifie' && state[key].dossier.etat === 'propose') || (state[key].dossier.etat === col))).map(key => <TrelloCard key={key} state={state} setState={setState} id={key} user={user} ></TrelloCard>)}
      </div>
    </>
  );
}

export default TrelloColumn;